import { Link } from 'react-router-dom';

const features = [
  { icon: 'ri-bookmark-line', title: '网址一键收藏', desc: '将动漫网入口地址尽收囊中，想看番直接进，无需反复搜索。' },
  { icon: 'ri-sort-desc', title: '分类清晰直达', desc: '六大热门分类一目了然，直达链接精准匹配你的口味。' },
  { icon: 'ri-refresh-line', title: '新番实时更新', desc: '第一时间掌握新番动态与动漫网主页导航更新。' },
];

export default function FeaturesCta() {
  return (
    <>
      <section className="mx-auto w-full max-w-6xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
          {features.map((f) => (
            <div key={f.title} className="rounded-lg border border-background-200 bg-background-100 p-6 text-center">
              <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                <i className={`${f.icon} text-2xl`} aria-hidden="true" />
              </span>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">{f.title}</h3>
              <p className="mt-2 text-sm text-foreground-500">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="relative mx-auto w-full max-w-6xl px-4 md:px-6 pb-12 md:pb-16">
        <div className="relative overflow-hidden rounded-xl">
          <img
            src="https://readdy.ai/api/search-image?query=energetic%20anime%20characters%20gathering%20together%20in%20celebration%20with%20confetti%20and%20sparkles%2C%20warm%20coral%20and%20amber%20palette%2C%20vibrant%20clean%20vector%20illustration%2C%20welcoming%20community%20atmosphere%2C%20wide%20banner&width=1400&height=500&seq=cta-bg-anime&orientation=landscape"
            alt="加入动漫网二次元社区"
            title="动漫网 - 收藏入口，加入社区"
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-900/85 to-accent-900/70" />
          <div className="relative z-10 flex flex-col items-center gap-4 px-6 py-12 text-center md:py-16">
            <h2 className="font-heading text-2xl text-background-50 md:text-3xl">把动漫网入口地址握在手里</h2>
            <p className="max-w-xl text-sm text-background-100/90 md:text-base">
              收藏动漫网官网首页直达链接，分类、直达、主页导航应有尽有。一键收藏，从此看番不再迷路。
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3">
              <Link
                to="/category"
                className="flex items-center gap-1.5 rounded-full bg-background-50 px-6 py-3 text-sm font-medium text-primary-700 hover:bg-secondary-100 transition-colors whitespace-nowrap"
              >
                <i className="ri-play-circle-fill" aria-hidden="true" />开始看番
              </Link>
              <Link
                to="/about"
                className="flex items-center gap-1.5 rounded-full bg-background-50/20 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur-sm hover:bg-background-50/30 transition-colors whitespace-nowrap"
              >
                <i className="ri-question-line" aria-hidden="true" />了解更多
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}